import actionTypes from './actionTypes';
import api, { createAuthenticatedApiInstance } from 'src/utils/api';
import { setAlert } from 'src/components/alert/actions';
import notifications from 'src/constants/notifications';
import { captureException } from '@sentry/nextjs';

export const fetchProfile = () => {
  return async (dispatch, getState) => {
    dispatch({ type: actionTypes.FETCH_PROFILE });
    try {
      const state = getState();
      const currentUser = state.context.currentUser;
      const api = createAuthenticatedApiInstance(getState); // to make authenticated requests on server
      const response = await api.get(`private/users/${currentUser.userId}/profile`);
      dispatch({
        type: actionTypes.FETCH_PROFILE_SUCCESS,
        data: response.data,
      });
    } catch (ex) {
      captureException(ex);
      dispatch({ type: actionTypes.FETCH_PROFILE_FAILURE, error: ex });
      dispatch(setAlert(ex.message));
    }
  };
};

export const updateBasics = (basicData) => {
  return async (dispatch, getState) => {
    dispatch({ type: actionTypes.UPDATE_PROFILE_BASICS });
    try {
      const state = getState();
      const currentUser = state.context.currentUser;
      const { data } = await api.put(`private/users/${currentUser.userId}/profile/basics`, {
        'basic-data': basicData,
      });
      dispatch({
        type: actionTypes.UPDATE_PROFILE_BASICS_SUCCESS,
        data,
      });
    } catch (ex) {
      captureException(ex);
      dispatch({ type: actionTypes.UPDATE_PROFILE_BASICS_FAILURE, error: ex });
      dispatch(setAlert(ex.message));
    }
  };
};

export const updateMarketResearchPreference = (enabled) => {
  return async (dispatch, getState) => {
    dispatch({ type: actionTypes.UPDATE_NOTIFICATION_PREFERENCE });
    try {
      const state = getState();
      const { userId } = state.context.currentUser;

      const response = await api.put('private/email-notifications', {
        userId,
        notificationPreferences: [{ notificationId: notifications.HU_RESEARCH_EMAILS, enabled }],
      });

      return dispatch({
        type: actionTypes.UPDATE_NOTIFICATION_PREFERENCE_SUCCESS,
      });
    } catch (ex) {
      captureException(ex);
      return dispatch({ type: actionTypes.UPDATE_NOTIFICATION_PREFERENCE_FAILURE, error: ex });
    }
  };
};
